// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, createProfileClient } from "../../Utils/Constants";

export const hitCreateProfileClientApi = createAsyncThunk(
  "hitCreateProfileClientApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("clientToken")}`,
        },
      };
      const url = ApiBaseUrl + createProfileClient;
      const response = await axios.put(url, payload, config);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
);

const CreateProfileClientSlice = createSlice({
  name: "createProfileClientReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitCreateProfileClientData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitCreateProfileClientApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitCreateProfileClientApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        if (
          action.payload?.status == true &&
          action.payload?.data?.accessToken
        ) {
          localStorage.setItem("clientToken", action.payload.data.accessToken);
          localStorage.setItem("clientId", action.payload.data._id);
          localStorage.setItem(
            "clientData",
            JSON.stringify(action.payload.data)
          );
        }
      })
      .addCase(hitCreateProfileClientApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitCreateProfileClientData } =
  CreateProfileClientSlice.actions;
export default CreateProfileClientSlice.reducer;
